import React, { useState } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import { DA_ButtonLink } from "@danishagro/shared/src/components/atoms/ButtonLink/ButtonLink.component";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_IconNames } from "@danishagro/shared/src/components/atoms/Icon/Icon.component";
import S from "./ShortDescriptionV1.module.scss";

interface V1Props {
    description?: string;
}

const V1 = ({ description }: V1Props) => {
    const { getDictionaryString } = useTranslations();
    const [toggleDescription, setToggleDescription] = useState(false);

    return description ? (
        <DA_Container>
            <div className={S.descriptionTextWrapper}>
                <DA_Text
                    className={cn(S.descriptionText, toggleDescription && S.showText)}
                    noPadding
                    html={description}
                />
                <DA_ButtonLink
                    icon={DA_IconNames.ChevronSmallDown}
                    className={cn(S.link, toggleDescription ? S.linkIconLess : S.linkIconMore)}
                    title={
                        toggleDescription
                            ? getDictionaryString("showLess")
                            : getDictionaryString("showMore")
                    }
                    onClick={() => setToggleDescription(!toggleDescription)}
                />
            </div>
        </DA_Container>
    ) : null;
};

export default V1;
